import { z } from "zod";

export const returnDecisionSchema = z.object({
  decision: z.enum(["confirm", "reject"]),
  reason: z.string().trim().max(500).optional().nullable(),
  signatureData: z.string().max(200_000).optional().nullable(),
});
